import { RunState } from "types/generated";
import { AccessResult } from "utils/access";
import RunPhaseLogs from "components/Run/elements/RunPhaseLogs";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import StopRunButton from "components/Run/elements/StopRunButton";
import KillRunButton from "components/Run/elements/KillRunButton";

import { RunHistoryEntryType } from "../../types";
import { useVisibilityToggle } from "../../hooks/useVisibilityToggle";

type InitializingEntryProps = {
  timestamp: number;
  until: number | null;
  stateVersion: number | null;
  hasLogs: boolean;
  openLogsByDefault: boolean;
  showTerminateButtons: boolean;
  beforeHooks: string[] | undefined;
  afterHooks: string[] | undefined;
  runId: string;
  stackId: string;
  isModuleRun: boolean;
  canStop: AccessResult;
  canKill: AccessResult;
  runQueryToRefetch: string;
};

const InitializingEntry = ({
  timestamp,
  until,
  stateVersion,
  hasLogs,
  openLogsByDefault,
  showTerminateButtons,
  beforeHooks,
  afterHooks,
  runId,
  stackId,
  isModuleRun,
  canStop,
  canKill,
  runQueryToRefetch,
}: InitializingEntryProps) => {
  const [showLogs, toggleLogs] = useVisibilityToggle(openLogsByDefault, hasLogs);

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Initializing}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
      onClick={toggleLogs}
      isOpen={showLogs}
    >
      {showLogs && (
        <RunPhaseLogs
          beforeHooks={beforeHooks}
          afterHooks={afterHooks}
          state={RunState.Initializing}
          stateVersion={stateVersion}
          until={until}
          runId={runId}
          stackId={stackId}
          isModuleRun={isModuleRun}
        >
          {showTerminateButtons && (
            <>
              <StopRunButton
                canStop={canStop}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
              <KillRunButton
                canKill={canKill}
                runId={runId}
                stackId={stackId}
                runQueryToRefetch={runQueryToRefetch}
              />
            </>
          )}
        </RunPhaseLogs>
      )}
    </HistoryEntryWrapper>
  );
};

export default InitializingEntry;
